const dimension = require('utils/dimension');
const $ = require('jquery');

/**
 * Sync height of children with data-* attribute (data-sync-height) of element with data-* attribute (data-sync-height-wrapper).
 * If another data-* attribute (data-additionalheight) is passed with a number it will add to the final height
 * @return {undefined}
 */
function syncHeight() {
	let $children;
	let max = -1;
	let height;
	const isMobile = dimension.isMobileWidth();

	function addHeight($jElemWrapper, $jElemChildren) {
		const addHeightvalue = $jElemWrapper.data('additionalheight') || 0;

		if (isMobile) {
			$jElemChildren.each((i, el) => {
				if (!addHeightvalue) {
					$(el).css('height', '');
				} else {
					$(el).css('height', el.offsetHeight + addHeightvalue);
				}
			});
		} else {
			$jElemChildren.each((i, el) => {
				height = el.offsetHeight;
				if (height > max) {
					max = height;
				}
			});
			$jElemChildren.css('height', max + addHeightvalue);
		}

		return -1;
	}

	const $syncHeight = $('[data-sync-height-wrapper]');
	$syncHeight.each((i, el) => {
		const $this = $(el);
		$children = $this.find('[data-sync-height]');
		$children.css('height', '');
		max = addHeight($this, $children);
	});
}

module.exports = syncHeight;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/syncHeight.js
 **/